module.exports = __webpack_public_path__ + "static/media/HelveticaNeueCyr-Black.0d40ee6d.woff2";